module.exports = __webpack_public_path__ + "img/dragon-tiger.23aaed5.png";